import React from "react";
import { GENDER_OPTIONS, getExperienceYearsList } from "../registrationWizardConstants";
import { isOptionalDobValid } from "../registrationWizardValidation";
import RegistrationWizardState from "../registrationWizardState";

const MONTHS = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

const DAYS = Array.from({ length: 31 }, (_, i) => String(i + 1));

const AboutYouStep = ({ showValidation }) => {
  const d = RegistrationWizardState.getStepData();
  const birthYears = getExperienceYearsList();
  const dobInvalid =
    showValidation &&
    !isOptionalDobValid(d.birthMonth.value, d.birthDay.value, d.birthYear.value);

  return (
    <div>
      <h2 className="clinician-onboard-title">Personal details</h2>

      <div className="clinician-onboard-field clinician-onboard-field--gender">
        <label>
          Gender <span className="required">*</span>
        </label>
        <div
          className={`clinician-onboard-gender-group ${
            showValidation && !d.gender.value ? "invalid" : ""
          }`}
        >
          {GENDER_OPTIONS.map((option) => (
            <label key={option.value} className="clinician-onboard-gender-option">
              <input
                type="radio"
                name="clinicianGender"
                className="clinician-onboard-radio"
                value={option.value}
                checked={d.gender.value === option.value}
                onChange={() => RegistrationWizardState.updateField("gender", option.value)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
        {showValidation && !d.gender.value && (
          <p className="clinician-onboard-field-error" role="alert">
            Please select your gender
          </p>
        )}
      </div>

      <div className="clinician-onboard-field">
        <label>Date of birth</label>
        <div className="clinician-onboard-dob-row">
          <select
            className={`clinician-onboard-select ${dobInvalid ? "invalid" : ""}`}
            value={d.birthMonth.value}
            onChange={(e) => RegistrationWizardState.updateField("birthMonth", e.target.value)}
          >
            <option value="">Month</option>
            {MONTHS.map((m) => (
              <option key={m.value} value={m.value}>
                {m.label}
              </option>
            ))}
          </select>
          <select
            className={`clinician-onboard-select ${dobInvalid ? "invalid" : ""}`}
            value={d.birthDay.value}
            onChange={(e) => RegistrationWizardState.updateField("birthDay", e.target.value)}
          >
            <option value="">Day</option>
            {DAYS.map((day) => (
              <option key={day} value={day}>
                {day}
              </option>
            ))}
          </select>
          <select
            className={`clinician-onboard-select ${dobInvalid ? "invalid" : ""}`}
            value={d.birthYear.value}
            onChange={(e) => RegistrationWizardState.updateField("birthYear", e.target.value)}
          >
            <option value="">Year</option>
            {birthYears.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>
        {dobInvalid && (
          <p className="clinician-onboard-field-error" role="alert">
            Please enter a complete valid date of birth, or leave it blank
          </p>
        )}
      </div>
    </div>
  );
};

export default AboutYouStep;
